
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 16\" id=\"play\" ><defs/><title>play</title><g id=\"play_Layer_2\" data-name=\"Layer 2\"><g id=\"play_Icons\"><path class=\"cls-1\" d=\"M0 0v16l16-8L0 0z\" id=\"play_play\"/></g></g></symbol>";
module.exports = sprite.add(image, "play");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.svg
// module id = 663
// module chunks = 1474